/*
 * Copyright © 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

export enum ClassValidatorErrors {
    ArrayContains = 'classValidator_arrayContains',
    ArrayMaxSize = 'classValidator_arrayMaxSize',
    ArrayMinSize = 'classValidator_arrayMinSize',
    ArrayNotContains = 'classValidator_arrayNotContains',
    ArrayNotEmpty = 'classValidator_arrayNotEmpty',
    ArrayUnique = 'classValidator_arrayUnique',
    Contains = 'classValidator_contains',
    Equals = 'classValidator_equals',
    IsAlpha = 'classValidator_isAlpha',
    IsAlphanumeric = 'classValidator_isAlphanumeric',
    IsArray = 'classValidator_isArray',
    IsAscii = 'classValidator_isAscii',
    IsBase64 = 'classValidator_isBase64',
    IsBoolean = 'classValidator_isBoolean',
    IsBooleanString = 'classValidator_isBooleanString',
    IsByteLength = 'classValidator_isByteLength',
    IsCreditCard = 'classValidator_isCreditCard',
    IsCurrency = 'classValidator_isCurrency',
    IsDate = 'classValidator_isDate',
    IsDateString = 'classValidator_isDateString',
    IsDefined = 'classValidator_isDefined',
    IsDivisibleBy = 'classValidator_isDivisibleBy',
    IsEmail = 'classValidator_isEmail',
    IsEmpty = 'classValidator_isEmpty',
    IsEnum = 'classValidator_isEnum',
    IsFQDN = 'classValidator_isFQDN',
    IsFullWidth = 'classValidator_isFullWidth',
    IsHalfWidth = 'classValidator_isHalfWidth',
    IsHexadecimal = 'classValidator_isHexadecimal',
    IsHexColor = 'classValidator_isHexColor',
    IsIn = 'classValidator_isIn',
    IsInstance = 'classValidator_isInstance',
    IsInt = 'classValidator_isInt',
    IsIP = 'classValidator_isIP',
    IsISBN = 'classValidator_isISBN',
    IsISIN = 'classValidator_isISIN',
    IsISO8601 = 'classValidator_isISO8601',
    IsJSON = 'classValidator_isJSON',
    IsLowercase = 'classValidator_isLowercase',
    IsMilitaryTime = 'classValidator_isMilitaryTime',
    IsMobilePhone = 'classValidator_isMobilePhone',
    IsMongoId = 'classValidator_isMongoId',
    IsMultibyte = 'classValidator_isMultibyte',
    IsNegative = 'classValidator_isNegative',
    IsNotEmpty = 'classValidator_isNotEmpty',
    IsNotIn = 'classValidator_isNotIn',
    IsNumber = 'classValidator_isNumber',
    IsNumberString = 'classValidator_isNumberString',
    IsOptional = 'classValidator_isOptional',
    IsPositive = 'classValidator_isPositive',
    IsString = 'classValidator_isString',
    IsSurrogatePair = 'classValidator_isSurrogatePair',
    IsUppercase = 'classValidator_isUppercase',
    IsUrl = 'classValidator_isUrl',
    IsUUID = 'classValidator_isUUID',
    IsVariableWidth = 'classValidator_isVariableWidth',
    Length = 'classValidator_length',
    Matches = 'classValidator_matches',
    Max = 'classValidator_max',
    MaxDate = 'classValidator_maxDate',
    IsInYear = 'classValidator_isInYear',
    MaxLength = 'classValidator_maxLength',
    Min = 'classValidator_min',
    MinDate = 'classValidator_minDate',
    MinLength = 'classValidator_minLength',
    NotContains = 'classValidator_notContains',
    notEquals = 'classValidator_notEquals',
    elohnIsSameOrAfter = 'classValidator_isSameOrAfter',
    elohnAhvNummer = 'classValidator_ahvNummer',
    elohnGeschlechtAusgewaehlt = 'classValidator_geschlechtAusgewaehlt',
    elohnNichtValidXML = 'classValidator_validXmlValue'
}
